export { renderTagPickerControl_unstable as renderTagPickerControl } from '@fluentui/react-tag-picker';
